import script from "./BrightcoveVideoModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrightcoveVideoModal.vue?vue&type=script&setup=true&lang=ts"

import "./BrightcoveVideoModal.vue?vue&type=style&index=0&id=ad9af3e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad9af3e4"]])

export default __exports__